module.exports = __webpack_public_path__ + "img/right-arm_active.58592e29.png";